module.exports = __webpack_public_path__ + "img/sport-e-salute-no-bg.ad82ada7.png";